<template>
  <div class="mb-steps">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.x + 'px' || 0 + 'px',
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
      }"
    />
    <div
      :key="'mb-step' + index"
      v-for="(step, index) in startGameConfig.steps"
      :style="[currentStep == index ? { 'z-index': 1, opacity: 1 } : { display: 'none' }]"
    >
      <div>
        <img
          class="mb-step-img"
          :src="giveMeImagePlease(step.imagePath)"
          :style="[
            {
              top: step.pos.y + 'px' || 0 + 'px',
              left: step.pos.x + 'px' || 0 + 'px',
              width: step.width + 'px' || 1920 + 'px',
              height: step.height + 'px' || 1080 + 'px',
            },
            step.cssStyle,
          ]"
        />
        <div
          v-if="step.controll"
          @click="
            setStep(index, step.controll, step.audio);
            animationState = false;
          "
          class="mb-step-controll-button"
          :class="{ 'stepp-button-anim': step.controll.animation && animationState }"
          :style="[
            {
              top: step.controll.pos.y + 'px' || 0 + 'px',
              left: step.controll.pos.x + 'px' || 0 + 'px',
              width: step.controll.width + 'px' || 0 + 'px',
              height: step.controll.height + 'px' || 0 + 'px',
              background: step.controll.background,
            },
            step.controll.cssStyle,
          ]"
        >
          <p class="mb-step-controll-button-text">
            {{ step.controll.text }}
          </p>
        </div>
        <mb-audio-in-game
          :key="data.top + data.left + 'audio' + indexMbAudio"
          v-for="(data, indexMbAudio) in step.mbAudioItemData"
          :item-data="data"
        ></mb-audio-in-game>
      </div>
    </div>
    <div
      class="steps-controlls"
      v-if="startGameConfig.stepper.show"
      :style="[startGameConfig.stepper.orientation == 'top' ? { top: 0 } : { bottom: 0 }]"
    >
      <div
        class="ball"
        @click="goToStep(index)"
        :style="[
          currentStep == index ? { opacity: 1 } : { opacity: 0.3 },
          { background: startGameConfig.stepper.color },
        ]"
        :key="'mb-step-controll-ball' + index"
        v-for="(ball, index) in startGameConfig.steps"
      ></div>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '../../../MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-steps',
  components: { mbAudioInGame },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      currentStep: 0,
      animationState: true,
      audio: null,
    };
  },
  created() {},
  beforeMount() {
    //this.init();
  },
  mounted() {},
  methods: {
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onpause: () => {
          console.log('end');
        },
        onstop: () => {
          console.log('end');
        },
      });
      console.log(this.audio);
      this.startAudio();
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    setStep(index, step, audio) {
      console.log(audio);
      if (this.currentStep != -1 && this.audio != null) {
        this.stopAudio();
      }
      if (audio) {
        this.setAudioConfig(audio.src, audio.volume);
      }
      if (step.type == 'next') {
        this.currentStep++;
      } else {
        this.currentStep--;
      }
      if (this.startGameConfig.steps[this.currentStep].end) {
        console.log('end');
        this.$store.dispatch('checkGame');
      }
    },
    checkGameAction() {
      if (this.startGameConfig.steps[this.currentStep].end) {
        return true;
      } else {
        return false;
      }
      // return this.status;
    },
    goToStep(index) {
      this.currentStep = index;
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.currentStep = 0;
      this.audio = null;
      this.animationState = true;
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
  },
  destroyed() {
    if (this.audio != null) {
      this.stopAudio();
    }
  },
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.mb-steps
  background-size: contain
  background-repeat: no-repeat
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  top: 0px
  .main-img
    position: fixed
    object-fit: cover
  .mb-step-controll-button, .mb-step-img
    position: absolute
  .mb-step-controll-button
    border-radius: 50%
    display: grid
    cursor: pointer
    .mb-step-controll-button-text
      align-self: center
      justify-self: center
      margin: 0 !important
      padding: 0 !important
  .steps-controlls
    position: fixed
    width: 100%
    height: 5vh
    background: rgba(0,0,0,.3)
    left: 0
    .ball
      height: 4vh
      margin: .5vh
      width: 4vh
      background: red
      border-radius: 50%
      transition: .5s
      display: inline-block
      align-self: center
      justify-self: center
      cursor: pointer
.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .1s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(1.5,1.5)
  opacity: 0
.stepp-button-anim
  animation: 2s 0s pulseStepp 10 linear backwards

  @keyframes pulseStepp
    0%
      transform: scale(1)
    35%
      transform: scale(1.2)
    70%
      transform: scale(1)
</style>
